import { useEffect, useState } from 'react'
//import {UserEditModalHeader} from './UserEditModalHeader'
//import {UserEditModalFormWrapper} from './UserEditModalFormWrapper'
import { ViewModalHeader } from './ViewModalHeader'
import axios from 'axios'
import { getclusterbyid, getclusterbyidtenant, getdevicesungroup, getdevicesungrouptenant, getips, getipstenant } from '../request/request'
import Swal from 'sweetalert2'
import { useAuth } from '../../../auth'
import { useAppSelector } from '../../../../../redux/hooks'
import { DemoModal } from '../../../../Modal_Demo/ViewModalDemo'
import { boolean } from 'yup'
import '../../../../styles/components/customSelects.css';

const API_URL = process.env.REACT_APP_API_URL

type ID = undefined | null | number

const EdistCluster = (props: any) => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  /**************************  CONSTANTES  ********************************/
  const [loading, setLoading] = useState(false)
  const { currentUser } = useAuth()
  const [ctxs, setctxs] = useState<any[]>([])
  const [Localpreferenceuno, setLocalpreferenceuno] = useState('')
  const [Localpreferencedos, setLocalpreferencedos] = useState('')
  const [isChecked, setIsChecked] = useState(false)

  const [DeviceSelect, setDeviceSelect1] = useState<any>()
  const [DeviceSelectdos, setDeviceSelect2] = useState<any>()
  const [Local_address, setLocalAddress] = useState('')
  const [Local_addressdos, setLocalAddressdos] = useState('')

  const Type = useAppSelector((state) => state.CloudSlice.Type)
  const tenant = useAppSelector((state) => state.TenantSlice.id)
  const Id = useAppSelector((state) => state.SuscriptionSlice.id)

  const [Clusterid, setCluster] = useState<any>({
    id: 0,
    name: '',
    description: '',
    enable: boolean,
    ctxr: [
      {
        subid: '',
        name: '',
        description: '',
        localpref: 0,
        statuspeer: null,
        lastupdatepeer: null,
        lastupdate: null,
        data: {
          cloud: '',
          region: ''
        },
        status: ''
      },
      {
        subid: '',
        name: '',
        description: '',
        localpref: 0,
        statuspeer: null,
        lastupdatepeer: null,
        lastupdate: null,
        data: {
          cloud: '',
          region: ''
        },
        status: ''
      }
    ],
    suscriptionId: 0
  })

  /************************** get de cluster por id ********************************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (props.id !== '' && props.id !== null) {
          if (tenant === 0 && Type !== 'Global') {
            const UserResponse = await getclusterbyid(Id, props.id)
            setCluster(UserResponse.data)
            setDeviceSelect1(UserResponse.data.ctxr[0].subid)
            setLocalpreferenceuno(UserResponse.data.ctxr[0].localpref)
            setIsChecked(UserResponse.data.enable)

            setDeviceSelect2(UserResponse.data.ctxr[1].subid)
            setLocalpreferencedos(UserResponse.data.ctxr[1].localpref)
          } else if (tenant !== 0 && Type !== 'Global') {
            const UserResponse = await getclusterbyidtenant(Id, props.id, tenant)
            setCluster(UserResponse.data)
            setDeviceSelect1(UserResponse.data.ctxr[0].subid)
            setLocalpreferenceuno(UserResponse.data.ctxr[0].localpref)
            setIsChecked(UserResponse.data.enable)

            setDeviceSelect2(UserResponse.data.ctxr[1].subid)
            setLocalpreferencedos(UserResponse.data.ctxr[1].localpref)
          } else if (tenant === 0 && Type === 'Global') {
            const UserResponse = await getclusterbyid(-1, props.id)
            setCluster(UserResponse.data)
            setDeviceSelect1(UserResponse.data.ctxr[0].subid)
            setLocalpreferenceuno(UserResponse.data.ctxr[0].localpref)
            setIsChecked(UserResponse.data.enable)

            setDeviceSelect2(UserResponse.data.ctxr[1].subid)
            setLocalpreferencedos(UserResponse.data.ctxr[1].localpref)
          } else if (tenant !== 0 && Type === 'Global') {
            const UserResponse = await getclusterbyidtenant(-1, props.id, tenant)
            setCluster(UserResponse.data)
            setDeviceSelect1(UserResponse.data.ctxr[0].subid)
            setLocalpreferenceuno(UserResponse.data.ctxr[0].localpref)
            setIsChecked(UserResponse.data.enable)

            setDeviceSelect2(UserResponse.data.ctxr[1].subid)
            setLocalpreferencedos(UserResponse.data.ctxr[1].localpref)
          }
        }
      } catch (error) {
        console.error('Error al obtener los clusters', error)
      }
    }
    fetchData()
  }, [props.id])

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (tenant === 0 && Type !== 'Global' && Clusterid.suscriptionId !== 0) {
          const UserResponse = await getdevicesungroup(Clusterid.suscriptionId)
          setctxs(UserResponse.data)
        } else if (tenant !== 0 && Type !== 'Global' && Clusterid.suscriptionId !== 0) {
          const UserResponse = await getdevicesungrouptenant(Clusterid.suscriptionId, tenant)
          setctxs(UserResponse.data)
        } else if (tenant === 0 && Type === 'Global' && Clusterid.suscriptionId !== 0) {
          const UserResponse = await getdevicesungroup(Clusterid.suscriptionId)
          setctxs(UserResponse.data)
        } else if (tenant !== 0 && Type === 'Global' && Clusterid.suscriptionId !== 0) {
          const UserResponse = await getdevicesungrouptenant(Clusterid.suscriptionId, tenant)
          setctxs(UserResponse.data)
        }
      } catch (error) {
        console.error('Error al obtener los permisos', error)
      }
    }
    fetchData()
  }, [Id, Clusterid.suscriptionId])

  const cambiarstate1 = (e: any) => {
    setDeviceSelect1(e.target.value)
  }

  const cambiarstate2 = (e: any) => {
    setDeviceSelect2(e.target.value)
  }

  /**************************** IPS **********************************/
  const [ip, setips] = useState<any[]>([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (DeviceSelect) {
          if (tenant === 0) {
            const UserResponse = await getips(DeviceSelect)
            setips(UserResponse.data)
          } else if (tenant !== 0) {
            const UserResponse = await getipstenant(DeviceSelect, tenant)
            setips(UserResponse.data)
          }
        }
      } catch (error) {
        console.error('Error al obtener los permisos', error)
      }
    }
    fetchData()
  }, [DeviceSelect])

  const [ipdos, setipsdos] = useState<any[]>([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (DeviceSelectdos) {
          if (tenant === 0) {
            const UserResponse = await getips(DeviceSelectdos)
            setipsdos(UserResponse.data)
          } else if (tenant !== 0) {
            const UserResponse = await getipstenant(DeviceSelectdos, tenant)
            setipsdos(UserResponse.data)
          }
        }
      } catch (error) {
        console.error('Error al obtener los permisos', error)
      }
    }
    fetchData()
  }, [DeviceSelectdos])

  /******************** función para editar ***********************/
  const handleSubmit = async (e: any) => {
    e.preventDefault()

    // VALIDACIONES
    if (Number(Localpreferenceuno) === Number(Localpreferencedos)) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'The Priorities cannot be the same. Please verify',
        showConfirmButton: true
      })
      return
    }

    if (
      Number(Localpreferenceuno) < 1 ||
      Number(Localpreferenceuno) > 1000 ||
      Number(Localpreferencedos) < 1 ||
      Number(Localpreferencedos) > 1000
    ) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Los valores de Priority deben estar entre 1 y 1000.',
        showConfirmButton: true
      })
      return
    }

    try {
      if (props.id !== null) {
        const actualizar = {
          name: Clusterid.name,
          suscriptionId: Clusterid.suscriptionId,
          description: Clusterid.description,
          ctxr: [
            {
              uuid: DeviceSelect,
              localpref: Localpreferenceuno,
              ip: Local_address
            },
            {
              uuid: DeviceSelectdos,
              localpref: Localpreferencedos,
              ip: Local_addressdos
            }
          ],
          enable: isChecked
        }

        if (tenant === 0 && Type !== 'Global') {
          await axios
            .put(API_URL + '/v1/ClusterCtxr/' + Clusterid.suscriptionId + '/' + props.id, actualizar)
            .then((res) => {
              if (res.data.error && res.data.error.includes('ip not found')) {
                Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: 'Ip not found',
                  showConfirmButton: false,
                  timer: 1500
                })
              } else {
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: 'Your Cluster has Update',
                  showConfirmButton: false,
                  timer: 1500
                })
              }
              props.setID(undefined)
              axios.get(API_URL + '/v1/ClusterCtxr/' + Clusterid.suscriptionId + '/list').then((res) => {
                props.setrecords(res.data)
              })
            })
        } else if (tenant !== 0 && Type !== 'Global') {
          await axios
            .put(
              API_URL + '/v1/ClusterCtxr/' + Clusterid.suscriptionId + '/' + props.id + '?tenantId=' + tenant,
              actualizar
            )
            .then((res) => {
              if (res.data.error && res.data.error.includes('ip not found')) {
                Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: 'Ip not found',
                  showConfirmButton: false,
                  timer: 1500
                })
              } else {
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: 'Your Cluster has Update',
                  showConfirmButton: false,
                  timer: 1500
                })
              }
              props.setID(undefined)
              return axios
                .get(API_URL + '/v1/ClusterCtxr/' + Clusterid.suscriptionId + '/list?tenantId=' + tenant)
                .then((res) => {
                  props.setrecords(res.data)
                })
            })
        } else if (tenant === 0 && Type === 'Global') {
          await axios
            .put(API_URL + '/v1/ClusterCtxr/' + Clusterid.suscriptionId + '/' + props.id, actualizar)
            .then((res) => {
              if (res.data.error && res.data.error.includes('ip not found')) {
                Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: 'Ip not found',
                  showConfirmButton: false,
                  timer: 1500
                })
              } else {
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: 'Your Cluster has Update',
                  showConfirmButton: false,
                  timer: 1500
                })
              }
              props.setID(undefined)
              axios.get(API_URL + '/v1/ClusterCtxr/' + -1 + '/list').then((res) => {
                props.setrecords(res.data)
              })
            })
        } else if (tenant !== 0 && Type === 'Global') {
          await axios
            .put(
              API_URL + '/v1/ClusterCtxr/' + Clusterid.suscriptionId + '/' + props.id + '?tenantId=' + tenant,
              actualizar
            )
            .then((res) => {
              if (res.data.error && res.data.error.includes('ip not found')) {
                Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: 'Ip not found',
                  showConfirmButton: false,
                  timer: 1500
                })
              } else {
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: 'Your Cluster has Update',
                  showConfirmButton: false,
                  timer: 1500
                })
              }
              props.setID(undefined)
              return axios.get(API_URL + '/v1/ClusterCtxr/' + -1 + '/list?tenantId=' + tenant).then((res) => {
                props.setrecords(res.data)
              })
            })
        }
      }
    } catch (error: any) {
      console.log(error)
    }
  }

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked)
  }

  useEffect(() => {
    if (DeviceSelect && ip.length > 0) {
      setLocalAddress(ip[0].value)
    }
  }, [DeviceSelect, ip])

  useEffect(() => {
    if (DeviceSelectdos && ipdos.length > 0) {
      setLocalAddressdos(ipdos[0].value)
    }
  }, [DeviceSelectdos, ipdos])

  // Aquí definimos la función que llamamos al hacer clic en el ícono
  const showPriorityInfo = () => {
    Swal.fire({
      title: 'Priority Explanation',
      html: `
        <p>This field determines the order in which announcements are made. 
        A higher value indicates a higher priority for initiating announcements.</p>
        <p>When comparing two entries, the one with the greater value serves 
        as the primary announcement channel, while the one with the lesser value 
        acts as a fallback.</p>
      `,
      icon: 'info',
      confirmButtonText: 'Got it!'
    })
  }

  return (
    <>
      {props.id !== null && (
        <div>
          <div
            className='modal fade show d-block'
            id='kt_modal_add_user'
            role='dialog'
            tabIndex={-1}
            aria-modal='true'
          >
            <div className='modal-dialog modal-dialog-centered mw-650px'>
              <div className='modal-content'>
                <ViewModalHeader setID={props.setID} />
                <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
                  <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit}>
                    <div className='text-center mb-5'>
                      <h1 className='text-marino fw-bolder mb-3 f-titulo fs-md'>Edit Cluster</h1>
                    </div>
                    <div className='d-flex align-items-center justify-content-end'>
                      <div className='form-check form-switch form-check-custom form-check-solid'>
                        <input
                          className='form-check-input border border-gray-300'
                          type='checkbox'
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                          value='activar'
                          id='activador'
                        />
                        <label className='form-check-label text-marino f-parrafo fw-bold'>
                          {isChecked ? 'Cluster On' : 'Cluster Off'}
                        </label>
                      </div>
                    </div>
                    <br />
                    <div className='row'>
                      <div className='col'>
                        <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor='name'>
                          Name
                        </label>
                        <input
                          type='text'
                          name='name'
                          value={Clusterid.name}
                          className='form-control form-control-solid border-gray-300 f-parrafo'
                          onChange={(e: any) => setCluster({ ...Clusterid, name: e.target.value })}
                        />
                      </div>
                      <div className='col'>
                        <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor='name'>
                          Description
                        </label>
                        <input
                          type='text'
                          name='name'
                          value={Clusterid.description}
                          className='form-control form-control-solid border-gray-300 f-parrafo'
                          onChange={(e: any) => setCluster({ ...Clusterid, description: e.target.value })}
                        />
                      </div>
                    </div>
                    <br />
                    {Clusterid.ctxr.map((ctx: any, index: any) => (
                      <div key={index} className='row'>
                        {index === 0 && (
                          <>
                            <div className='col'>
                              <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo'>
                                CTX-R 1
                              </label>
                              <div className='select-container'>
                                <select
                                  className='custom-select'
                                  aria-label='Select example'
                                  onChange={cambiarstate1}
                                >
                                  <option value={ctx.subid}>
                                    {ctx.name} ({ctx.description})
                                  </option>
                                  {ctxs.map((ins: any, x: any) => (
                                    <option key={x} value={ins.id}>
                                      {ins.name} ({ins.description})
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className='col'>
                              <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo'>
                                IP for HA
                              </label>
                              <div className='select-container'>
                                <select
                                  className='custom-select'
                                  aria-label='Select example'
                                  onChange={(e) => setLocalAddress(e.target.value)}
                                  value={Local_address}
                                >
                                  {ip?.length === 0 && <option disabled selected hidden>No data</option>}
                                  <option disabled selected hidden>Select an IP</option>
                                  {ip.map((ips: any, x: any) => (
                                    <option key={x} value={ips.value}>
                                      {ips.value}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className='col'>
                              <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo'>
                                Priority
                              </label>
                              {/* ícono clicable: Al hacer clic => showPriorityInfo() */}
                              <i
                                className="fas fa-exclamation-circle ms-2 fs-7"
                                style={{ cursor: 'pointer' }}
                                onClick={showPriorityInfo}
                              ></i>
                              <input
                                type='number'
                                min={1}
                                max={1000}
                                name='localpref'
                                className='form-control form-control-solid border border-gray-300 f-parrafo'
                                id='Localpref'
                                defaultValue={Localpreferenceuno}
                                onChange={(e: any) => setLocalpreferenceuno(e.target.value)}
                              />
                            </div>
                          </>
                        )}
                        {index === 1 && (
                          <>
                            <div className='col'>
                              <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo'>
                                CTX-R 2
                              </label>
                              <div className='select-container'>
                                <select
                                  className='custom-select'
                                  aria-label='Select example'
                                  onChange={cambiarstate2}
                                >
                                  <option value={ctx.subid}>
                                    {ctx.name} ({ctx.description})
                                  </option>
                                  {ctxs.map((ins: any, x: any) => (
                                    <option key={x} value={ins.id}>
                                      {ins.name} ({ins.description})
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className='col'>
                              <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo'>
                                IP for HA
                              </label>
                              <div className='select-container'>
                                <select
                                  className='custom-select'
                                  aria-label='Select example'
                                  onChange={(e) => setLocalAddressdos(e.target.value)}
                                  value={Local_addressdos}
                                >
                                  {ipdos?.length === 0 && <option disabled selected hidden>No data</option>}
                                  <option disabled selected hidden>Select an IP</option>
                                  {ipdos.map((ips: any, x: any) => (
                                    <option key={x} value={ips.value}>
                                      {ips.value}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className='col'>
                              <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo'>
                                Priority
                              </label>
                              {/* ícono clicable: Al hacer clic => showPriorityInfo() */}
                              <i
                                className="fas fa-exclamation-circle ms-2 fs-7"
                                style={{ cursor: 'pointer' }}
                                onClick={showPriorityInfo}
                              ></i>
                              <input
                                type='number'
                                min={1}
                                max={1000}
                                name='localpref'
                                className='form-control form-control-solid border border-gray-300 f-parrafo'
                                id='Localpref'
                                defaultValue={Localpreferencedos}
                                onChange={(e: any) => setLocalpreferencedos(e.target.value)}
                              />
                            </div>
                          </>
                        )}
                      </div>
                    ))}
                    <br />
                    {currentUser?.is_demo !== true && (
                      <div className='d-grid mb-10 justify-content-center'>
                        <div className='row'>
                          <div className='col'>
                            <button type='submit' id='kt_sign_in_submit' className='btn btn-primary'>
                              {!loading && <span className='indicator-label'>Save</span>}
                              {loading && (
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                  Please wait...
                                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                              )}
                            </button>
                          </div>
                          <div className='col'>
                            <button
                              className='btn border border-pink text-pink f-parrafo'
                              style={{ width: '200px' }}
                              onClick={() => props.setID(undefined)}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className='modal-backdrop fade show'></div>
        </div>
      )}
    </>
  )
}

export { EdistCluster }
